export default __webpack_public_path__ + "static/media/1.6bca6e6b.pdf";